import React from 'react';
import { observer, inject } from 'mobx-react';
import autobind from 'autobind';
import isNil from 'lodash/isNil';

import { Input, InputProps, MaskedInput, PhoneInput } from '@components/Input';
import { CountryCode } from 'chaika-enums';

import { AppState } from '@store/App/App';

import { profileForm } from '../profileForm';

interface Props extends Partial<InputProps> {
    name: string;
    mask?: string;
    country?: CountryCode;
}

interface StoreProps {
    app: AppState;
}

@observer
class Component extends React.Component<Props & StoreProps> {
    public render(): React.ReactNode {
        const { app, name, mask, ...props } = this.props;

        const value = profileForm.getFieldValue<string>(name !== 'age' ? name : 'ageString');

        const showValidStatus =
            name !== 'age' &&
            app.isOnValidation &&
            (profileForm.isFieldRequired(name) || (!isNil(value) && value !== ''));

        const commonProps = {
            ...props,
            name,
            value,
            showValidStatus,
            dataTest: `createPatient_${name}`,
            autoComplete: 'new-password',
            isValid: profileForm.isFieldValid(name),
            onBlur: this.handleInputBlur,
        };

        if (props.type === 'tel') {
            return React.createElement(PhoneInput, { ...commonProps, onCountryChange: this.handleCountryChange });
        }

        if (mask) {
            return React.createElement(MaskedInput, { ...commonProps, mask });
        }

        return React.createElement(Input, commonProps);
    }

    @autobind
    protected async handleInputBlur(event: React.ChangeEvent<HTMLInputElement>) {
        const { name } = this.props;
        const { value } = event.target;

        profileForm.setFieldValue(name, value);
    }

    @autobind
    protected async handleCountryChange(newPhone: string) {
        const { name } = this.props;

        profileForm.setFieldValue(name, newPhone);
    }
}

export const CreateInputContainer = inject<Props, StoreProps>(AppState.Name)(Component);
